import { useEffect, useState } from 'react'
import { estadoDaInstalacao } from './estadoDaInstalacao'

// ⚠ Ate 23/08/2026 o app nao tinha NADA disto: era instalavel (manifest certo,
// PNG 192/512 no ar, service worker servido) e simplesmente ninguem oferecia.
// Os 2 representantes do beta abriram o link e usaram como site. O Chrome do
// Android nao mostra banner sozinho ha anos, e o navegador de dentro do
// WhatsApp -- por onde ela distribui -- nao instala nada, jamais.
//
// A decisao de QUAL caso e este mora em estadoDaInstalacao.ts, testada. Aqui e
// so tela.

/** O evento do Chrome, que nao esta na tipagem padrao do DOM. */
type EventoDeInstalar = Event & { prompt: () => Promise<void> }

export default function BotaoInstalar() {
  const [evento, setEvento] = useState<EventoDeInstalar | null>(null)
  const [instalouAgora, setInstalouAgora] = useState(false)

  useEffect(() => {
    function guardarOEvento(e: Event) {
      // Sem o preventDefault o navegador segue com o fluxo dele e o evento se
      // perde -- e o botao apareceria sem ter o que chamar.
      e.preventDefault()
      setEvento(e as EventoDeInstalar)
    }
    function marcarInstalado() {
      setEvento(null)
      setInstalouAgora(true)
    }
    window.addEventListener('beforeinstallprompt', guardarOEvento)
    window.addEventListener('appinstalled', marcarInstalado)
    return () => {
      window.removeEventListener('beforeinstallprompt', guardarOEvento)
      window.removeEventListener('appinstalled', marcarInstalado)
    }
  }, [])

  const { estado, sistema } = estadoDaInstalacao({
    temEventoDeInstalar: evento !== null,
    estaEmModoApp:
      instalouAgora || window.matchMedia('(display-mode: standalone)').matches,
    userAgent: navigator.userAgent,
  })

  if (estado === 'ja-instalado' || estado === 'nada-a-fazer') return null

  const caixa = 'bg-teal-50 border border-teal-200 rounded-xl p-4 text-sm'

  if (estado === 'pode-instalar') {
    return (
      <div className={caixa}>
        <p className="text-slate-700 mb-3">
          Deixe o CRM na tela do seu celular: abre mais rápido e funciona sem sinal.
        </p>
        <button
          type="button"
          onClick={() => void evento?.prompt()}
          className="w-full bg-teal-700 text-white rounded-lg py-2 font-medium"
        >
          Instalar o app
        </button>
      </div>
    )
  }

  const instrucao =
    estado === 'navegador-interno'
      ? sistema === 'ios'
        ? 'Você abriu por dentro de outro aplicativo, e daqui não dá para instalar. Toque nos três pontinhos e escolha "Abrir no Safari" — lá aparece a opção.'
        : 'Você abriu por dentro de outro aplicativo, e daqui não dá para instalar. Toque nos três pontinhos e escolha "Abrir no Chrome" — lá aparece a opção.'
      : estado === 'iphone'
        ? 'Para deixar o CRM na tela do seu iPhone: toque no botão de compartilhar (o quadrado com a seta para cima) e escolha "Adicionar à Tela de Início".'
        : 'Para deixar o CRM na tela do seu celular: toque nos três pontinhos do Chrome e escolha "Instalar aplicativo".'

  return (
    <div className={caixa}>
      <p className="text-slate-700">{instrucao}</p>
    </div>
  )
}
